var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Should convert')},model:{value:(_vm.shouldConvert),callback:function ($$v) {_vm.shouldConvert=$$v},expression:"shouldConvert"}})}
var staticRenderFns = []

export { render, staticRenderFns }